import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const BASE_CLS = cn(
  "w-full min-h-[48px] box-border inline-flex items-center justify-center px-[18px]",
  "rounded-xl border border-border bg-white/[0.015]",
  "text-[15px] font-medium leading-none text-foreground/90",
  "transition-colors duration-150 cursor-pointer",
  "hover:bg-secondary/60 hover:border-foreground/20 hover:text-foreground",
  "focus-visible:outline-none focus-visible:border-athlynx/60 focus-visible:ring-[3px] focus-visible:ring-athlynx/20",
  "active:translate-y-px",
  "disabled:opacity-50 disabled:cursor-not-allowed"
);

/** DashboardCardAction — shared secondary footer button for dashboard cards. */
export default function DashboardCardAction({ to, onClick, disabled, children, testid, className }) {
  if (to) {
    return (
      <Link to={to} className={cn(BASE_CLS, className)} data-testid={testid}>
        {children}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={cn(BASE_CLS, className)} data-testid={testid}>
      {children}
    </button>
  );
}
